import {useNavigate} from "react-router";
import {useEffect, useState} from "react";
import {useAuthStore} from "../../../store/auth.store";
import {PartnerApi} from "../../../api/partner.api";
import {toast} from "react-toastify";
import {useTranslation} from "../../../hooks/useTranslation";

export default function CompanyBranchEditForm({handleClose, company_id, company_branch, callback}) {
    const { t } = useTranslation();
    const token = useAuthStore((state) => state.token);

    const createCompanyBranch = (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        const result = PartnerApi.companyCompanyBranchUpdate({
            token,
            company_id,
            company_branch_id: company_branch.company_branch_id,
            data: {
                city: formData.get("city"),
                country: formData.get("country"),
                name: formData.get("name"),
                street: formData.get("street"),
                zip: formData.get("zip"),
            }
        });
        result.then((result) => {
            if ("error" in result) {
                toast.error(result.error);
                return;
            }

            handleClose();
            if (callback) {
                callback();
            }
        });
        return false;
    }
    return (
        <form onSubmit={(e) => createCompanyBranch(e)}>
            <div className="mb-10">
                <label className="required form-label">{t("deliveryAddress.name")}</label>
                <input name="name" className="form-control" defaultValue={company_branch.name} />
            </div>
            <div className="mb-10">
                <label className="required form-label">{t("deliveryAddress.street")}</label>
                <input name="street" className="form-control" defaultValue={company_branch.street} />
            </div>
            <div className="mb-10">
                <label className="required form-label">{t("deliveryAddress.city")}</label>
                <input name="city" className="form-control" defaultValue={company_branch.city} />
            </div>
            <div className="mb-10">
                <label className="required form-label">{t("deliveryAddress.zip")}</label>
                <input name="zip" className="form-control" defaultValue={company_branch.zip} />
            </div>
            <div className="mb-10">
                <label className="required form-label">{t("deliveryAddress.country")}</label>
                <input name="country" className="form-control" defaultValue={company_branch.country} />
            </div>


            <button type="submit" className="btn btn-primary">{t("common.save")}</button>
        </form>
    );
}